<!-- compareRejectedReason should be false here, as it adds a StringEquals rule to the product activation rules which doesn't make sense -->
<!-- as there are automations that have been created with this value true changing it will cause the rule parsing in the frontend to break -->
<!-- comparing empty string (rejected reason selected by the user) to empty string (rejected reason from the event) will be true so it works as long as we leave this -->
<automata-product-activation-panel
  #commonProductPanel
  [triggerChoices]="triggerChoices"
  [taskDefinitionId]="taskDefinitionId"
  [automation]="automation"
  [compareRejectedReason]="true"
  [includeTrialSelection]="true"
  [descriptionTranslationId]="'AUTOMATIONS.EDITOR.TRIGGERS.PRODUCT_ACTIVATION.PRODUCT_ACTIVATED.PRODUCT_ACTIVATED'"
></automata-product-activation-panel>
